import React from "react";
import { Link } from "react-router-dom";
import "./styles.less";
// import { useTranslation } from "react-i18next";

export const BlogBanner = (props) => {
  const { title, subTitle, img, article } = props;
  // const { t } = useTranslation();
  return (
    <section>
      <div className="blog-banner-warp">
        <div className="blog-banner">
          {/* <div className="banner-img">
            {imgurl && <img src={`//files.authing.co/authing-website${imgurl}`} alt="" />}
            {children}
          </div> */}
          <div className="blog-banner-img">
            <img src={img} alt="authing blog banner" />
          </div>
          <div className="banner-content">
            <div className="blog-banner-title">{title}</div>
            <div className="blog-banner-subtitle">{subTitle}</div>
          </div>
          <Link to={`/blog/${article.id}`} className="blog-banner-button">
            查看文章
          </Link>
        </div>
      </div>
    </section>
  );
};
